import React from "react";
import parse from "html-react-parser";
import { usePrivacy } from "..";
import { LoadingSpinner } from "shared";

export const PrivacyAndPolicy = () => {
  const { settingsInfo } = usePrivacy({ load: true, key: "page_privacy" });
  const { data, isLoading } = settingsInfo;

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="terms-faq-privacy-section">
      <div className="page-header-left col-12 col-md-8">
        <h2 className="page-title ellipsis-text">
          Privacy Policy for Nergy India Pvt Ltd
        </h2>
      </div>
      <p>{data ? parse(data?.content) : ""}</p>
    </div>
  );
};
